<template>
    <div class="CShareEmail">
        <CButton
            class="w-full"
            :disabled="preview"
            icon="email"
            label-class="sm:hidden"
            title="Poslať emailom"
            @click="emailLink(url, subject, body)"
        >
            Email
        </CButton>
    </div>
</template>

<script setup lang="ts">
import { useSharing } from '@/composables/sharing/useSharing'

interface Props {
    url: string
    scale?: string
    subject?: string
    body?: string
    preview?: boolean
}

withDefaults(defineProps<Props>(), {
    scale: '',
    subject: '',
    body: '',
    preview: false
})

const { objectToGetParams } = useSharing()

const emailLink = (url: string, subject: string, body: string) => {
    window.open(
        'mailto:' +
            objectToGetParams({
                subject,
                body: body || url
            }),
        '__blank'
    )
}
</script>
